import * as React from 'react';
import styled from 'styled-components';
import { ColorEnum } from '../../enum/color.enum';
import { LAYERS_DIV_ID } from '../../constants';
import * as ReactDOM from 'react-dom';
import Helmet from 'react-helmet-async';
import { FullScreenContainer } from './atoms';
import { IInjectedProps } from '../../interface/component/injected-props.interface';
import { inject } from 'mobx-react';
import VisibilitySensor from 'react-visibility-sensor';

export const keylineHeight = 2;

const ContentContainer = styled.div`
  font-size: 14px;
  display:flex;
  color: ${ColorEnum.ContentColor};
`;
const HeaderWrapper = styled.div`
    align-items: center;
    display: flex;
    flex: 0 0 auto;
    justify-content: space-between;
    transition: box-shadow 200ms;
    box-shadow:  0 ${keylineHeight}px 0 0 ${ColorEnum.AltoGray};
`;

export interface IBlocksDialogProps {
  header?: React.ReactNode;
  footer?: React.ReactNode;
  content: React.ReactNode;
  containerStyle?: React.CSSProperties;
  contentContainerStyle?: React.CSSProperties;
  width?: number;
  height?: number;
  onClose: (event: any) => void;
  fullScreen?: boolean;
  onBottomContentVisibilityChange?: (isVisible: boolean) => void;
}

interface IFullScreenContainerProps {
  fullScreen?: boolean;
  width?: number;
  height?: number;
  innerHeight?: number;
}
const isSafariOnIos = /iPhone OS/i.test(navigator.userAgent) && /Safari/i.test(navigator.userAgent);
const Container = styled.div`
  margin-top: ${(props: IFullScreenContainerProps) => props.fullScreen ? 0 : 60}px;
  margin-left: auto;
  margin-right: auto;
  background: white;
  display:flex;
  flex-direction: column;
  margin-bottom:${(props: IFullScreenContainerProps) => props.fullScreen ? '100px' : '0px'};
  height: ${(props: IFullScreenContainerProps) => props.fullScreen ? isSafariOnIos ? '88vh' : `100vh` : `${(props.height ? `${props.height}px` : 'calc(100% - 120px)')}`};
  width: ${(props: IFullScreenContainerProps) => props.fullScreen ? '100vw' : `${(props.width ? props.width : 600)}px`};
`;
const FullScreenContentContainer = styled.div`
  flex:1;
  overflow-y:auto;
`;

const DialogTitle = styled.div``;

const SensorBlock = styled.div`
  height: 30px;
  width: 30px;
`;

@inject('dispatch')
export class BlocksDialog extends React.Component<IBlocksDialogProps & IInjectedProps> {

  constructor(props) {
    super(props);
  }

  onLink = (event) => {
    const link = event.target.getAttribute('href');
    const target = event.target.getAttribute('target');
    const protocol = event.target.protocol;
    if (protocol === 'mailto:') {
      return;
    }
    if (!target || target === '_self') {
      event.preventDefault();
      this.props.dispatch.redirectPage(link);
    } else {
      this.props.dispatch.openNewTab(link);
    }
  }

  onVisibilityChange = (newVisibility) => {
    if (this.props.onBottomContentVisibilityChange) {
      this.props.onBottomContentVisibilityChange(newVisibility);
    }
  }

  render() {
    const props = this.props;
    const header = props.header ? <HeaderWrapper>
      <DialogTitle>
        {props.header}
      </DialogTitle>
    </HeaderWrapper> : null;
    const content = this.props.content;
    const footer = props.footer ? props.footer : null;

    return (
      <>
        <Helmet>
          <style>
            {
              `body {
                                overflow: hidden;
                            }`
            }
          </style>
        </Helmet>
        {
          ReactDOM.createPortal(
            <FullScreenContainer
              style={{ zIndex: 100000 }}
              onClick={props.onClose}
            >
              <Container
                style={props.containerStyle}
                fullScreen={props.fullScreen}
                height={props.height}
                width={props.width}
                onClick={(e) => {
                  if ((e.target as any).tagName === 'A') {
                    this.onLink(e);
                  }
                  const protocol = (e.target as any).protocol;
                  if (protocol !== 'mailto:') {
                    // Leave mailto: links to propagate as this is the only way to open the email client
                    e.stopPropagation();
                    e.preventDefault();
                  }
                }}
              >

                {header}
                <FullScreenContentContainer>
                  <ContentContainer
                    style={props.contentContainerStyle}
                    key="ContentContainer"
                  >
                    {content}
                  </ContentContainer>

                  <VisibilitySensor partialVisibility={true} onChange={this.onVisibilityChange}>
                    <SensorBlock />
                  </VisibilitySensor>
                  {this.props.fullScreen && <div style={{ height: '70px' }}>&nbsp;</div>}
                </FullScreenContentContainer>
                {this.props.fullScreen ? <div style={{ position: 'fixed', bottom: 0, left: 0, zIndex: 1000, background: 'white', width: '100vw', paddingBottom: isSafariOnIos ? '30px' : '15px' }}>
                  {footer}
                </div> :
                  footer}
              </Container>
            </FullScreenContainer>, document.getElementById(LAYERS_DIV_ID))
        }
      </>
    );
  }
}
